export const Basepath = window.API_URI;
// export const Basepath = "http://52.5.61.215:3010";
// export const Basepath = "http://54.161.147.1:3010";
// export const Basepath = 'http://localhost:3200';
